// SINGLETON: Only this file may access import.meta.env

const required = {
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
} as const

for (const [key, value] of Object.entries(required)) {
  if (!value) throw new Error(`Missing required environment variable: ${key}`)
}

export const config = {
  supabaseUrl: required.VITE_SUPABASE_URL as string,
  supabaseAnonKey: required.VITE_SUPABASE_ANON_KEY as string,
  apiBaseUrl: required.VITE_API_BASE_URL as string,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  sentryEnvironment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) ?? 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const
